import { render, staticRenderFns } from "./BidsDownload.vue?vue&type=template&id=5b6a77e7&scoped=true&"
import script from "./BidsDownload.vue?vue&type=script&lang=js&"
export * from "./BidsDownload.vue?vue&type=script&lang=js&"
import style0 from "./BidsDownload.vue?vue&type=style&index=0&id=5b6a77e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a77e7",
  null
  
)

export default component.exports